import { Box, Divider, Grid } from '@material-ui/core'
import React from 'react'
import {
  DeleteWithConfirmButton,
  EditButton,
  Show,
  ShowProps,
  SimpleShowLayout,
  TextField,
  TitleProps,
  useShowContext,
  useTranslate,
} from 'react-admin'
import { ResourceName } from '../../../../core/ResourceName'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'
import { EngineMediaActionDto } from '../../../../core/dto/engine-media/engine-media-action.dto'

interface EngineMediaActionTitleProps extends TitleProps {
  record?: EngineMediaActionDto
}

const ShowTitle = (data: EngineMediaActionTitleProps) => {
  const { record: action } = data
  const translate = useTranslate()

  return (
    <span>
      {translate('resources.engine-media-actions.titles.show')}: {action?.id}
    </span>
  )
}

const GeneralActions = () => {
  const { record: action } = useShowContext<EngineMediaActionDto>()
  const hasAuthority = useHasAuthority()

  return (
    <>
      <Divider />
      <Box p={1} display="flex" justifyContent="flex-end">
        <Grid container direction="row" justify="flex-end" alignItems="center">
          <Grid item style={{ margin: '2px' }}>
            <DeleteWithConfirmButton
              basePath={`/${ResourceName.ENGINE_MEDIA_ACTIONS}`}
              record={action}
              variant="contained"
              disabled={!hasAuthority(Authority.DELETE_ENGINE_MEDIA_ACTIONS)}
            />
          </Grid>
          <Grid item>
            <EditButton
              variant="contained"
              basePath="/engine-media-actions"
              record={action}
              style={{ margin: '2px' }}
              disabled={!hasAuthority(Authority.EDIT_ENGINE_MEDIA_ACTIONS)}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

const EngineMediaActionTabs = ({ ...props }) => (
  <SimpleShowLayout {...props}>
    <TextField source="id" label="ID" />
    <TextField source="mediaAction" />
    <TextField source="name" />
    <GeneralActions />
  </SimpleShowLayout>
)

export const EngineMediaActionShow = (props: ShowProps) => (
  <Show {...props} actions={false} title={<ShowTitle />}>
    <EngineMediaActionTabs />
  </Show>
)
